import { adminHttpClient } from '../commons/adminHttpClient'

export type SyncWithAdpProps = {
  companyId: string
  productId: number
}

const syncWithAdp = (request: SyncWithAdpProps): Promise<void> => {
  return adminHttpClient.post(`/Companies/SyncWithAdp`, request)
}

export default syncWithAdp
